import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { login, getUserInfoByTempToken } from '../services/authServices';
import { useSiteContext } from '../context/SiteContext';
import logger from '../utils/logger';

const useLoginSubmit = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { setToken, setIsAuthenticated, setUser } = useSiteContext();
    
    useEffect(() => {
        // Note: get query params from URL to determine if editing or creating
        const queryParams = new URLSearchParams(window.location.search);
        const tempTokenFromUrl = queryParams.get('temp_token');
        if (tempTokenFromUrl) {
            autoLoginWithTempToken(tempTokenFromUrl);
        }
    }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
        setValue,
        clearErrors
    } = useForm({
        defaultValues: {
            email: '',
            password: '',
            rememberMe: false
        },
        mode: 'onSubmit'
    });

    const onSubmit = async (data) => {
        setLoading(true);
        clearErrors();

        try {
            const response = await login({
                email: data.email,
                password: data.password,
                rememberMe: data.rememberMe
            });
            logger("log", "response", response);
            if (response.success && response.token) {
                localStorage.setItem('token', response.token);
                localStorage.setItem('user', JSON.stringify(response.user));
                setToken(response.token);
                setIsAuthenticated(true);
                setUser(response.user);
                toast.success('Login successful!');
                if (localStorage.getItem('roomId')) {
                    navigate(`/${localStorage.getItem('roomId')}`);
                } else {
                    navigate('/dashboard');
                }
            } else {
                // throw new Error('No token received');
                setError('email', {
                    type: 'manual',
                    message: 'Invalid email or password'
                });
            }

        } catch (error) {
            logger("log", "error", error);
            const errorMessage = error.response?.data?.message || 'Login failed. Please try again.';
            // Set form error for general submission
            setError('email', {
                type: 'manual',
                message: errorMessage
            });
        } finally {
            setLoading(false);
        }
    };

    const autoLoginWithTempToken = async (tempToken) => {
        setLoading(true);
        try {
            // Note: Get user info using the temp token
            const userInfo = await getUserInfoByTempToken(tempToken);
            if (userInfo && userInfo.data) {
                const response = await login({
                    email: userInfo.data.email,
                    password: 'xxxxxxxx',
                    auto_login: true,
                });
                if (response.success && response.token) {
                    localStorage.setItem('token', response.token);
                    localStorage.setItem('user', JSON.stringify(response.user));
                    setToken(response.token);
                    setIsAuthenticated(true);
                    setUser(response.user);
                    toast.success('Login successful!');
                    if (localStorage.getItem('roomId')) {
                        navigate(`/${localStorage.getItem('roomId')}`);
                    } else {
                        navigate('/dashboard');
                    }
                } else {
                    // throw new Error('No token received');
                    setError('email', {
                        type: 'manual',
                        message: 'Invalid email or password'
                    });
                }
            } else {
                toast.error(userInfo?.message || "Auto-login failed. Please login manually.");
            }
        } catch (error) {
            logger("log", "auto login error", error);
            toast.error('Auto login failed. Please login manually.');
        } finally {
            setLoading(false);
        }
    };

    return {
        register,
        handleSubmit: handleSubmit(onSubmit),
        errors,
        loading,
        onSubmit,
        setValue
    };
};

export default useLoginSubmit;
